import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from './cn.js';
export function Card({ title, action, className, children, ...rest }) {
    return (_jsxs("section", { className: cn('rounded-xl border border-stone-800 bg-stone-950/40 p-4', className), ...rest, children: [(title || action) && (_jsxs("header", { className: "mb-3 flex items-center justify-between gap-3", children: [title && _jsx("h2", { className: "text-lg font-medium", children: title }), action] })), children] }));
}
//# sourceMappingURL=card.js.map